export enum DiscountTypeEnum {
  Cash = 0,
  Percentage
}
